import {RouterModule, Routes} from '@angular/router';

import {HomeComponent} from './home/home.component';
import {CookiestermsComponent} from './cookiesterms/cookiesterms.component';
import {LegaltermsComponent} from './legalterms/legalterms.component';
import {PrivacytermsComponent} from './privacyterms/privacyterms.component';
import {FaqComponent} from './faq/faq.component';
import {TermsconditionsComponent} from './termsconditions/termsconditions.component';

/**
 * Site page Routes
 *
 * @author Fran Aragon
 */
const sitePagesRoutes: Routes = [
    {path: 'home', component: HomeComponent},
    {path: 'faq', component: FaqComponent},
    {path: 'cookiesterms', component: CookiestermsComponent},
    {path: 'legalterms', component: LegaltermsComponent},
    {path: 'termsconditions', component: TermsconditionsComponent},
    {path: 'privacyterms', component: PrivacytermsComponent},
    {path: '', redirectTo: '/home', pathMatch: 'full'}
];

/**
 * Site page Routes
 */
export const SITE_PAGES_ROUTES = RouterModule.forChild(sitePagesRoutes);
